export default "__VITE_ASSET__df0b2f15__"